export default __webpack_public_path__ + "static/salesforce-cbb4000012f6e40cdf877d7487608a77.png";